import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "Migrate"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M19.5 1.5H4.5C3.67157 1.5 3 2.17157 3 3V6C3 6.82843 3.67157 7.5 4.5 7.5H11.25V12.1275L9.3075 10.1925L8.25 11.25L12 15L15.75 11.25L14.6925 10.1925L12.75 12.1275V7.5H19.5C20.3284 7.5 21 6.82843 21 6V3C21 2.17157 20.3284 1.5 19.5 1.5ZM4.5 3H7.5V6H4.5V3ZM19.5 6H9V3H19.5V6ZM19.5 16.5H4.5C3.67157 16.5 3 17.1716 3 18V21C3 21.8284 3.67157 22.5 4.5 22.5H19.5C20.3284 22.5 21 21.8284 21 21V18C21 17.1716 20.3284 16.5 19.5 16.5ZM4.5 18H15V21H4.5V18ZM19.5 21H16.5V18H19.5V21Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/Migrate.vue"]]);
